import { render } from "./PayGradesManagement.vue?vue&type=template&id=224d2e54&scoped=true"
import script from "./PayGradesManagement.vue?vue&type=script&lang=js"
export * from "./PayGradesManagement.vue?vue&type=script&lang=js"

import "./PayGradesManagement.vue?vue&type=style&index=0&id=224d2e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224d2e54"]])

export default __exports__